import { ReportActionTypes } from '../report.action-types'

const initialStates = {
    users: [],
    userMetadata: {},
    userQueries: {},
    userLoading: false,
    userDetail: {},
    firearms: [],
    insurances: [],
    inspections: [],
    safeStorages: [],
    accessories: [],
    parts: [],
    ammunitions: [],
    invoices: [],
}

const UserReportReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ReportActionTypes.GET_USER_REPORT:
            return {
                ...state,
                // users: action.payload,
            }
        case ReportActionTypes.GET_USERS:
            return {
                ...state,
                ...action.payload,
            }
        case ReportActionTypes.SET_USER_QUERIES:
            return {
                ...state,
                userQueries: action.payload,
            }
        case ReportActionTypes.SET_USER_LOADING:
            return {
                ...state,
                userLoading: action.payload,
            }
        case ReportActionTypes.GET_USER_DETAIL:
            return {
                ...state,
                userDetail: action.payload,
            }
        case ReportActionTypes.GET_USER_FIREARMS:
            return {
                ...state,
                firearms: action.payload,
            }
        case ReportActionTypes.GET_USER_INSURANCES:
            return {
                ...state,
                insurances: action.payload,
            }
        case ReportActionTypes.GET_USER_INSPECTIONS:
            return {
                ...state,
                inspections: action.payload,
            }
        case ReportActionTypes.GET_USER_SAFE_STORAGES:
            return {
                ...state,
                safeStorages: action.payload,
            }
        case ReportActionTypes.GET_USER_ACCESSORIES:
            return {
                ...state,
                accessories: action.payload,
            }
        case ReportActionTypes.GET_USER_PARTS:
            return {
                ...state,
                parts: action.payload,
            }
        case ReportActionTypes.GET_USER_AMMUNITIONS:
            return {
                ...state,
                ammunitions: action.payload,
            }
        case ReportActionTypes.GET_USER_INVOICES:
            return {
                ...state,
                invoices: action.payload,
            }
        default:
            return state
    }
}

export default UserReportReducer
